// **************************************************
// Toggle class
// **************************************************
const toggleHideClass = (element, toggle) => {
  element.classList.toggle('hide', toggle);
};

const toggleIsMatchedClass = (element, toggle) => {
  element.classList.toggle('is-matched', toggle);
};

// **************************************************
// Load more
// **************************************************
const articleListElem = document.querySelector('.article-list');
const articleListMoreButton = document.querySelector('.article-list__load-more');

// Show remaining items
const showItemsOnLoadMore = (classNames) => {
  const matchedItem = document.querySelectorAll(classNames);
  matchedItem.forEach((el, i) => {
    const remainingItems = document.querySelectorAll(classNames);
    if (i < 12) {
      toggleHideClass(el, false);
    }

    toggleHideClass(articleListMoreButton, remainingItems.length === 1);
  });
};

const loadMoreAction = () => {
  attachEvent('.article-list__load-more', 'click', (ev) => {
    const checkedItem = document.querySelector('.article-list input[name="types"]:checked');
    if (checkedItem) {
      showItemsOnLoadMore('.article-list__item.hide.is-matched');
    } else {
      toggleHideClass(articleListMoreButton, false);
      showItemsOnLoadMore('.article-list__item.hide');
    }
  });
};

if (articleListElem) {
  loadMoreAction();
}

// **************************************************
// Show not found message
// **************************************************
const showNotFoundMessage = () => {
  const hideItems = document.querySelectorAll('.article-list__item.hide');
  const totalItems = document.querySelectorAll('.article-list__item');
  const notFound = document.querySelector('.article-list__not-found');
  toggleHideClass(notFound, true);
  if (hideItems.length === totalItems.length) {
    toggleHideClass(notFound, false);
    toggleHideClass(articleListMoreButton, true);
  }
};

// **************************************************
// Category filter
// **************************************************
const getFilterPosts = (selectedItem) => {
  document.querySelectorAll('.article-list__item').forEach((ele) => {
    const tag = ele.querySelector('.tag').innerHTML;
    toggleHideClass(ele, false);

    if (selectedItem !== tag.trim()) {
      toggleHideClass(ele, true);
    } else {
      toggleIsMatchedClass(ele, true);
    }

    if (selectedItem === 'all') {
      toggleIsMatchedClass(ele, true);
      toggleHideClass(ele, false);
    }
  });

  const result = document.querySelectorAll('.article-list__item:not(.hide)');
  result.forEach((el, i) => {
    if (i > 11) {
      toggleHideClass(articleListMoreButton, false);
      toggleHideClass(el, true);
    }
  });
  showNotFoundMessage();
};

if (articleListElem) {
  const dropdownListInput = articleListElem.querySelectorAll('.dropdown__list-item input');
  dropdownListInput.forEach((ele) => {
    ele.addEventListener('click', (ev) => {
      const checkedItemId = ev.target.getAttribute('id');
      if (ev.target.getAttribute('id') === 'all') {
        getFilterPosts(checkedItemId);
        return;
      }

      let flag = 0;
      document.querySelectorAll('.article-list__item').forEach((element) => {
        const tag = element.querySelector('.tag').innerHTML;
        toggleHideClass(element, false);
        toggleIsMatchedClass(element, false);
        if (ev.target.getAttribute('data-title') === tag.trim()) {
          toggleIsMatchedClass(element, true);

          flag += 1;
          if (flag > 12) {
            toggleHideClass(articleListMoreButton, false);
            toggleHideClass(element, true);
          } else {
            toggleHideClass(articleListMoreButton, true);
          }
        } else {
          toggleHideClass(element, true);
        }
        showNotFoundMessage();
      });
    });
  });
}

// Active filters category by hash value
if (window.location.hash) {
  document.querySelectorAll('.article-list .dropdown__list-item .dropdown__list-option').forEach((ev) => {
    const parentEle = ev.closest('.dropdown__list-item');
    const categoryTitle = parentEle.querySelector('input').getAttribute('data-title');
    const categoryId = parentEle.querySelector('input').getAttribute('id');
    if (categoryId === window.location.hash.substring(1)) {
      parentEle.querySelector('input').checked = true;
      document.querySelector('.dropdown__placeholder-text').innerHTML = categoryTitle;
      getFilterPosts(categoryTitle);
    }
  });
}
